import React, { useEffect } from "react";
import {
  Typography,
  Box,
  Grid,
  useMediaQuery,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { Helmet } from "react-helmet";
import { Add, Remove } from "@mui/icons-material";
import { useTheme } from "@mui/system";
import { connect } from "react-redux";
import { homeActions } from "actions";
import SecondaryCenterTemplate from "components/SecondaryCenterTemplate";

const FAQ = (props) => {
  const theme = useTheme();
  const {
    getContentType,
    contentInfo,
    gtmInfo,
    updateGTMDataLayer,
    organizationInfo,
  } = props;
  const isSmallScreen = useMediaQuery("(max-width:1000px)");
  const [faqData, setFaqData] = React.useState([]);
  const [expandAll, setExpandAll] = React.useState(false);
  const tagManagerArgs = {
    dataLayer: gtmInfo,
    dataLayerName: "PageDataLayer",
  };
  const isLoggedIn = JSON.parse(sessionStorage.getItem("isLoggedIn"));

  useEffect(() => {
    props.setValue(4);
    getContentType("FAQ");
    document.getElementById("appcontent").scroll(0, 0);
    // window.dataLayer.push(tagManagerArgs);

    updateGTMDataLayer({
      event: "Nav_faqs",
      page: "Global",
      screen: "FAQ",
      screen_title: "Global",
    });

    return () => {
      updateGTMDataLayer({
        event: "Nav_faqs",
        page: "Global",
        screen: "FAQ",
        screen_referrer: "FAQ",
        screen_title: "Global",
      });
    };
  }, []);

  useEffect(() => {
    window.dataLayer.push({
      ...tagManagerArgs.dataLayer,
    });
  }, [gtmInfo]);

  useEffect(() => {
    if (
      contentInfo &&
      contentInfo.FAQ &&
      contentInfo.FAQ.content &&
      contentInfo.FAQ.content.length
    ) {
      let result = [];
      contentInfo.FAQ.content.forEach((item) => {
        if (item.sectionContent && item.sectionContent.length) {
          item.sectionContent.forEach((element, index) => {
            const d1 = element;
            d1.description = d1.description.replace(
              "${domain}",
              window.location.host
            );
            d1.description = d1.description.replace(
              "${appid}",
              localStorage.getItem("orgCode")
            );
            d1.isExpanded = false;
            d1.id = index;
            if (isLoggedIn) {
              d1.description = d1.description.replace(
                '<a href="sign-up">Sign up</a>',
                "Sign up"
              );
            }
            result.push(d1);
          });
        }
      });
      setFaqData(result);
    }
  }, [contentInfo]);

  const handleChange = (panel) => {
    const listItems = faqData.map((resource) => {
      let panelItem;
      if (panel.id === resource.id) {
        panelItem = {
          ...resource,
          isExpanded: resource.isExpanded ? false : true,
        };
      } else {
        panelItem = resource;
      }
      return panelItem;
    });
    setFaqData(listItems);
  };

  const handleExpandAll = () => {
    setExpandAll(true);
    const listItems = faqData.map((resource) => {
      return { ...resource, isExpanded: true };
    });
    setFaqData(listItems);
  };

  const handleCollapseAll = () => {
    setExpandAll(false);
    const listItems = faqData.map((resource) => {
      return { ...resource, isExpanded: false };
    });
    setFaqData(listItems);
  };
  return (
    <SecondaryCenterTemplate pageTitle="Frequently Asked Questions">
      <Helmet>
        <title>
          Frequently Asked Questions |{" "}
          {organizationInfo?.app?.appCode === "CVD"
            ? "Cuverd® Partner"
            : "Cuverd®"}
        </title>
        <meta
          name="description"
          content="FAQs about the free prescription savings and discount app Cuverd and website–including how it works, sign up, how to get prescription discounts, and more."
        />
        <meta
          property="og:title"
          content="Frequently Asked Questions | Cuverd®"
        />
        <meta
          property="og:description"
          content="FAQs about the free prescription savings and discount app Cuverd and website–including how it works, sign up, how to get prescription discounts, and more."
        />
        <meta
          property="og:image"
          content="assets/images/cuverd-logo-header.png"
        />
        <link
          rel="alternate"
          href="https://www.cuverd.com/frequently-asked-questions"
          hrefLang="en-us"
        />
        <link
          rel="canonical"
          href="https://www.cuverd.com/frequently-asked-questions"
        />
      </Helmet>
      <Grid container>
        <Grid item xs={12} sm={12} sx={{ margin: "auto" }}>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "24px",
              }}
              justifyContent={isSmallScreen ? "center" : "flex-start"}
            >
              <Button
                variant="outline"
                sx={{
                  color: expandAll ? undefined : "#859aa0",
                  borderColor: expandAll ? undefined : "#859aa0",
                }}
                onClick={handleExpandAll}
              >
                Expand all
              </Button>
              &nbsp; &nbsp;
              <Button
                variant="outline"
                sx={{
                  color: expandAll ? "#859aa0" : undefined,
                  borderColor: expandAll ? "#859aa0" : undefined,
                }}
                onClick={handleCollapseAll}
              >
                Collapse all
              </Button>
            </Box>
            <Box sx={{ minHeight: 500, overflowY: "auto" }}>
              {faqData.map((question) => {
                return (
                  <Accordion
                    key={question.title}
                    expanded={question.isExpanded}
                    sx={{
                      boxShadow: "none",
                      borderTop: "1px solid #0000001f",
                    }}
                    onChange={() => handleChange(question)}
                  >
                    <AccordionSummary
                      expandIcon={
                        question.isExpanded ? (
                          <Remove
                            sx={{ color: theme.palette.common.greenThree }}
                            fontSize="large"
                          />
                        ) : (
                          <Add
                            sx={{ color: theme.palette.common.greenThree }}
                            fontSize="large"
                          />
                        )
                      }
                      sx={{
                        margin: 0,
                        marginTop: "20px",
                        marginBottom: question.isExpanded ? "1px" : "18px",
                        textAlign: "left",
                      }}
                    >
                      <Typography variant="h3LatoBold">
                        {question.title}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{ margin: 0, paddingY: 0, textAlign: "left" }}
                    >
                      <Box mb={"18px"}>
                        <Typography
                          variant="h2LatoRegular"
                          sx={{
                            color: theme.palette.common.textGrey1,
                            lineHeight: "24px",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: question.description,
                          }}
                        ></Typography>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </SecondaryCenterTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    contentInfo: state.contentType.data,
    gtmInfo: state.gtmInfo.data,
    organizationInfo: state.organizationInfo.data,
  };
};

const mapDispatchToProps = {
  getContentType: (type) => homeActions.getContentType(type),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
};

export default connect(mapStateToProps, mapDispatchToProps)(FAQ);
